import { render, staticRenderFns } from "./CancelAccount.vue?vue&type=template&id=3da0b418&scoped=true&"
import script from "./CancelAccount.vue?vue&type=script&lang=js&"
export * from "./CancelAccount.vue?vue&type=script&lang=js&"
import style0 from "./CancelAccount.vue?vue&type=style&index=0&id=3da0b418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0b418",
  null
  
)

export default component.exports